<div
  #container
  class="collision-picker-container"
  *ngIf="!!model.kfzTyp"
  [ngClass]="{ disabled: model.disabled }"
  data-test="gsm-collision-picker_container"
>
  <div class="svg-container">
    <img [src]="backgroundImagePath()"/>
  </div>
  <div class="selection-overlay" data-test="gsm-collision-picker_selection">
    <div
      *ngFor="let i of [].constructor(9); index as index"
      [ngClass]="{ active: selection.includes(index) }"
      class="selection-tile"
      (click)="updateKfzIndex(index)"
    ></div>
  </div>
</div>
